/*
A modal component to add lading status

How to use in other components:
- add @ViewChild(LadingStatusModalComponent) name_here!: LadingStatusModalComponent;
- create a boolean to determine whether modal should be open or not. initialize it to false
- set the boolean to be true when you want to open the modal
- create a function to set the boolean to false
- <app-lading-status-modal *ngIf="boolean_here" (closeModal)="function_here()" [lading_uuid]="some_uuid_here"></app-lading_status_modal>
- closModal() retuns 0 - no action - cancelled    1 - successfully added status     2 - error
*/



import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { STATUSES } from '../work-orders/select-options'
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
@Component({
  selector: 'app-lading-status-modal',
  templateUrl: './lading-status-modal.component.html',
  styleUrls: ['./lading-status-modal.component.scss']
})
export class LadingStatusModalComponent {
  @Input() lading_uuid: string | undefined | null;
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();

  status_options = STATUSES;
  status_form: FormGroup = this.fb.group({
    status: ['', Validators.required],
    date: [new Date(), Validators.required],
    time: ['', [Validators.required, Validators.pattern(/^([01]\d|2[0-3]):[0-5]\d$/)]],
    timezone: ['', Validators.required]
  })
  saving = false;
  saveErrorMessage = '';
  saveErrorTitle = 'Status not saved';
  saveErrorIsChronology = false;
  confirmingMidnight = false;
  timezone_regions: {[index: string]: string} = {
    'America/Toronto': 'ON',
    'America/Vancouver': 'BC',
    'America/Edmonton': 'AB',
    'America/Montreal': 'QC',
    'America/Chicago': 'IL',
    'America/Halifax': 'NS',
    'America/Dawson_Creek': 'BC',
    'America/Regina': 'SK',
    'America/Winnipeg': 'MB',
    'America/Los_Angeles': 'CA',
    'America/New_York': 'NY',
    'America/Detroit': 'MI',
    'America/Thunder_Bay': 'ON',
    'America/St_Johns': 'NL',
    'America/Swift_Current': 'SK',
    'America/Denver': 'CO',
    'America/Indiana/Indianapolis': 'IN',
    'America/Indiana/Knox': 'IN',
    'America/Indiana/Marengo': 'IN',
    'America/Indiana/Petersburg': 'IN',
    'America/Indiana/Tell_City': 'IN',
    'America/Indiana/Vevay': 'IN',
    'America/Indiana/Vincennes': 'IN',
    'America/Indiana/Winamac': 'IN',
    'America/Kentucky/Louisville': 'KY',
    'America/Kentucky/Monticello': 'KY',
    'America/North_Dakota/Beulah': 'ND',
    'America/North_Dakota/Center': 'ND',
    'America/North_Dakota/New_Salem': 'ND',
    'America/Boise': 'ID',
    'America/Whitehorse': 'YT',
    'America/Yellowknife': 'NT',
    'America/Rainy_River': 'ON',
    'America/Dawson': 'YT',
    'America/Rankin_Inlet': 'NU',
    'America/Goose_Bay': 'NL',
    'America/Iqaluit': 'NU',
    'America/Inuvik': 'NT',
    'America/Juneau': 'AK',
    'America/Cambridge_Bay': 'NU',
    'America/Yakutat': 'AK'
  }
  shipper_timezone: string | null = null;
  consignee_timezone: string | null = null;

  ngOnInit(){
    // here, make a call to get shipper and consignee's timezone ids
    let url = `/api/work_orders/new_work_order_grid_details.php?uuid=${this.lading_uuid}`;
    this.http.get<any>(url).subscribe(response => {
      console.log(response);
      if(response.shipper.address.timezone_id){
        let shipper_timezone: string = response.shipper.address.timezone_id;
        if(shipper_timezone in this.timezone_regions){
          let strToAdd: string = ' - SHIPPER'
          this.timezone_regions[shipper_timezone] += strToAdd;
          this.shipper_timezone = shipper_timezone;
        }
      }
      if(response.consignee.address.timezone_id){
        let consignee_timezone: string = response.consignee.address.timezone_id;
        if(consignee_timezone in this.timezone_regions){
          this.consignee_timezone = consignee_timezone;
          let strToAdd: string = this.shipper_timezone == this.consignee_timezone && this.shipper_timezone !== null ? ', ' : ' - ';
          strToAdd += 'CONSIGNEE';
          this.timezone_regions[consignee_timezone] += strToAdd;

        }
      }
    })

    this.status_form.valueChanges.subscribe(() => { this.saveErrorMessage = ''; });

    this.status_form.get('status')?.valueChanges.subscribe(value => {
      this.setAutoselectedTimezone();
    });
  }

  setAutoselectedTimezone(){
    const timezones = this.getOrderedTimezones();
    const currentTimezone = this.status_form.get('timezone')?.value;
    if(currentTimezone === '' || currentTimezone === null){
      if(this.shipper_timezone !== null || this.consignee_timezone !== null){
        this.status_form.get('timezone')?.setValue(timezones[0]);
      }
      else{
        this.status_form.get('timezone')?.setValue('America/Toronto');
      }
    }
    return timezones;
  }

  getOrderedTimezones(){
    console.log(`status is: `,  this.status_form.get('status')?.value);
    if(this.status_form.get('status')?.value != '' && this.shipper_timezone !== null && this.status_form.get('status')?.value.includes('Shipper')){
      return [this.shipper_timezone, ...Object.keys(this.timezone_regions).filter(key => key !== this.shipper_timezone)]
    }
    else if(this.status_form.get('status')?.value != '' && this.consignee_timezone !== null && this.status_form.get('status')?.value.includes('Consignee')){
      return [this.consignee_timezone, ...Object.keys(this.timezone_regions).filter(key => key !== this.consignee_timezone)]
    }
    else{
      return Object.keys(this.timezone_regions);
    }
  }

  constructor(private fb: FormBuilder, private http: HttpClient, private dialog: MatDialog){
    
  }

  onCloseModal(is_successful: any){
    this.closeModal.emit(is_successful);
  }

  onSubmit(): void {
    if (this.saving || this.confirmingMidnight) return;
    this.saveErrorMessage = '';
    this.status_form.markAllAsTouched();
    if (this.status_form.invalid) return;

    const value = this.status_form.getRawValue();
    if (!(value.date instanceof Date) || Number.isNaN(value.date.getTime())) {
      this.status_form.get('date')?.setErrors({ invalidDate: true });
      return;
    }

    const postData = {
      lading_uuid: this.lading_uuid,
      lading_status: value.status,
      selected_date: this.convertDate(value.date),
      selected_time: value.time,
      selected_timezone: value.timezone
    };
    // A native time input supplies HH:mm. Never convert an empty value to midnight.
    if (postData.selected_time === '00:00') {
      this.confirmingMidnight = true;
      this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: 'Save this status at midnight?',
          message: `Save "${postData.lading_status}" at 12:00 AM (00:00) on ${postData.selected_date} in ${postData.selected_timezone}?\n\nMidnight is the start of this date in the selected timezone.`,
          confirmText: 'Save at midnight',
          cancelText: 'Change time',
          tone: 'warning'
        }
      }).afterClosed().pipe(take(1)).subscribe(confirmed => {
        this.confirmingMidnight = false;
        if (confirmed === true) this.saveStatus(postData);
      });
      return;
    }

    this.saveStatus(postData);
  }

  private saveStatus(postData: {
    lading_uuid: string | undefined | null;
    lading_status: string;
    selected_date: string;
    selected_time: string;
    selected_timezone: string;
  }): void {
    this.saving = true;
    this.http.post<any>('/api/lading_status/add_lading_status.php', postData).subscribe({
      next: response => {
        this.saving = false;
        // The legacy PHP proxy can return an API rejection with HTTP 200.
        if (response?.success === false || response?.ok === false || Number(response?.code) >= 400) {
          this.showSaveError(response);
          return;
        }
        this.onCloseModal(1);
      },
      error: error => { this.saving = false; this.showSaveError(error?.error); }
    });
  }

  private showSaveError(response: unknown): void {
    let body = response;
    if (typeof body === 'string') {
      try { body = JSON.parse(body); } catch { body = null; }
    }
    const failure = body && typeof body === 'object' ? body as { message?: unknown; error?: unknown } : null;
    const chronologyErrors = ['status_time_conflict', 'closure_time_conflict', 'future_status_time',
      'transport_time_order_conflict', 'consolidation_time_order_conflict', 'derived_correction_after_closure'];
    this.saveErrorIsChronology = typeof failure?.error === 'string' && chronologyErrors.includes(failure.error);
    this.saveErrorTitle = this.saveErrorIsChronology
      ? 'These times got a little out of order.' : 'Status not saved';
    this.saveErrorMessage = typeof failure?.message === 'string' && failure.message.trim()
      ? failure.message : 'The status could not be saved. Please check the details and try again.';
  }

  convertDate(date: any){
    // Get day, month, and year from dateObject
    const day = date.getDate();
    const month = date.getMonth() + 1; // Month is 0-based
    const year = date.getFullYear();

    // Construct the formatted date string
    const formattedDate = this.padZero(month) + '/' + this.padZero(day) + '/' + year;

    return formattedDate;
  }

  // Helper function to pad single-digit numbers with a leading zero
  padZero(num: number): string {
    return num < 10 ? '0' + num : '' + num;
  }

  // Transform timezone id value for display
  formatTimezoneString(timezone: string){
    return timezone.replace('_',' ').split('/').pop() || '';
  }

}
